import React, { useState } from "react";
import CartRowForCheckOut from "../components/CartRowForCheckOut";
import useShopStore from "../store/useShopStore";
import { useNavigate } from "react-router";
import Button from "../utils/Button";
import InputText from "../utils/InputText";
import PageHeading from "../utils/PageHeading";
import useAppStore from "../store/useAppStore";
import { toast } from "react-toastify";
import classes from "./Checkout.module.css";
import paypal from "../assests/images/paypal.png";
import masterCard from "../assests/images/masterCard.png";
import cash from "../assests/images/dollar.png";
import ButtonLink from "../utils/ButtonLink";

export default function Checkout() {
  const { cart, creatOrder } = useShopStore((state) => state);
  const [formData, setFormData] = useState({
    street: "",
    houseNumber: "",
    pinCode: "",
    state: "",
    payment: "",
    totalPrice: cart?.totalPrice,
  });
  const navigate = useNavigate();

  const handleChange = (event) => {
    const { name, value } = event.target;
    const newFormData = { ...formData };
    newFormData[name] = value;
    setFormData(newFormData);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    creatOrder(formData);

    setTimeout(() => {
      navigate("/");
    }, 5000);

    useAppStore.setState({ notify: "Order has been created" });

    toast(useAppStore.getState().notify);
  };

  return (
    <div>
      <PageHeading>Check out</PageHeading>
      {/* {loading && <Spinner />} */}
      <div className={classes.totalPrice}>
        <h2
          style={{
            textAlign: "right",
            margin: "2rem",
            fontSize: "2.4rem",
            display: "flex",
            gap: "2.5rem",
            alignItems: "center",
          }}
        >
          <span style={{ fontSize: "1.8rem" }}>Total Amount</span>
          {cart?.totalPrice} EUR
        </h2>
      </div>
      <div className={classes.checkoutMainContainer}>
        <form onSubmit={handleSubmit} className={classes.checkout}>
          <h2>Adress</h2>
          <InputText
            onChange={handleChange}
            style={{ width: "100%" }}
            placeholder="Street"
            type="text"
            name="street"
          />
          <InputText
            onChange={handleChange}
            style={{ width: "100%" }}
            placeholder="House Nummber"
            type="text"
            name="houseNumber"
          />
          <InputText
            onChange={handleChange}
            style={{ width: "100%" }}
            placeholder="state"
            type="text"
            name="state"
          />
          <InputText
            onChange={handleChange}
            style={{ width: "100%" }}
            placeholder="Pin Code"
            type="number"
            name="pinCode"
          />
          <div className={classes.checkoutActions}>
            <Button
              style={{ width: "100%" }}
              onSubmit={handleSubmit}
              type="submit"
            >
              Create Order
            </Button>
            <ButtonLink to="/cart">Go Back to cart</ButtonLink>
          </div>
        </form>
        <div className={classes.payment}>
          <fieldset className={classes.paymentBox}>
            <div className={classes.paymentMehod}>
              <div className={classes.paymentRadio}>
                <input
                  onChange={handleChange}
                  type="radio"
                  id="cash"
                  name="payment"
                  value="cash"
                />
                <label htmlFor="cash">Cash</label>
              </div>
              <div className={classes.paymentIconContainer}>
                <img width="100%" alt="payment" src={cash} />
              </div>
            </div>
            <div className={classes.paymentMehod}>
              <div className={classes.paymentRadio}>
                <input
                  onChange={handleChange}
                  type="radio"
                  id="masterCard"
                  name="payment"
                  value="masterCard"
                />
                <label htmlFor="masterCard">MasterCard</label>
              </div>
              <div className={classes.paymentIconContainer}>
                <img width="100%" alt="payment" src={masterCard} />
              </div>
            </div>
            <div className={classes.paymentMehod}>
              <div className={classes.paymentRadio}>
                <input
                  onChange={handleChange}
                  type="radio"
                  id="paypal"
                  name="payment"
                  value="paypal"
                />
                <label htmlFor="paypal">PayPal</label>
              </div>
              <div className={classes.paymentIconContainer}>
                <img width="100%" alt="payment" src={paypal} />
              </div>
            </div>
          </fieldset>
        </div>
        <div className={classes.checkOutcartContainer}>
          {cart?.products.map((product) => {
            return (
              <CartRowForCheckOut
                image={product.productId.image}
                qty={product.quantity}
                price={product.priceTotal}
                name={product.productId.name}
                key={product.productId._id}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
